import axios from 'axios';
import { auth } from './firebase';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});

// Attach Firebase JWT to every request
api.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    const token = await user.getIdToken();
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (process.env.NODE_ENV === 'development') {
      console.error('[API Error]', err.response?.data || err.message);
    }
    return Promise.reject(err);
  }
);

// Emergency
export const reportEmergency = (data) => api.post('/api/emergency/report', data);
export const getActiveIncidents = (params) => api.get('/api/emergency/active', { params });
export const updateIncidentStatus = (id, data) => api.patch(`/api/emergency/${id}/status`, data);

// AI
export const chatWithAI = (data) => api.post('/api/ai/chat', data);
export const analyzeIncident = (data) => api.post('/api/ai/analyze-incident', data);
export const predictRisk = (data) => api.post('/api/ai/predict-risk', data);
export const verifyIncident = (data) => api.post('/api/ai/verify-incident', data);
export const simulateCrisis = (data) => api.post('/api/ai/simulate-crisis', data);
export const postCrisisLearn = (data) => api.post('/api/ai/post-crisis-learn', data);

// Analytics
export const getDashboardAnalytics = () => api.get('/api/analytics/dashboard');

// Responders
export const getAvailableResponders = () => api.get('/api/responder/available');
export const assignResponder = (data) => api.post('/api/responder/assign', data);

// Streaming chat (direct fetch for SSE)
export const streamChatWithAI = async (message, userId, context, onToken) => {
  const user = auth.currentUser;
  let token = '';
  if (user) token = await user.getIdToken();

  const response = await fetch(`${BASE_URL}/api/ai/chat-stream`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ message, userId, context }),
  });

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split('\n');
    buffer = lines.pop();
    for (const line of lines) {
      if (line.startsWith('data: ')) {
        const chunk = line.slice(6);
        if (chunk !== '[DONE]') onToken(chunk);
      }
    }
  }
};

export default api;
